import keys from 'lodash.keys';
import values from 'lodash.values';
import i18nMessages from '../i18n/messages';

const DEFAULT_OPENING_TIME = {
  open: {},
  close: {},
  isOpened: false,
};

const errorMsgs = {
  default: i18nMessages['pt-BR']['opening_times.validation.default'],
  comparison: i18nMessages['pt-BR']['opening_times.validation.comparison'],
  weekIsClosed: i18nMessages['pt-BR']['opening_times.validation.closedWeek'],
};

const timeToInteger = time => {
  if (typeof time !== 'string') return undefined;

  const normalized = normalizeTime(time);

  return parseInt(normalized.replace(/[:]/g, '').replace(/[_]/g, ''), 10);
};

//  TODO: remove when facelift test is over
//  i.e. no dealers seing the old interface
const normalizeTime = time => {
  const [strHours, strMinutes] = time.split(':');

  return `${strHours}:${strMinutes}`;
};

const isTimeValid = time => {
  if (!time) return false;

  if (time.length === 8) {
    const normalizedTime = normalizeTime(time);

    return isTimeValid(normalizedTime);
  }

  if (time.length !== 5) return false;

  const hasUnderline = time.indexOf('_') !== -1;

  if (hasUnderline) return false;

  const [strHours, strMinutes] = time.split(':');

  const hours = parseInt(strHours, 10);
  const minutes = parseInt(strMinutes, 10);

  const isValidHours = hours >= 0 && hours < 24;
  const isValidMinutes = minutes >= 0 && minutes < 60;

  return isValidHours && isValidMinutes;
};

const isTimeComparisonValid = (open, close) => timeToInteger(open) >= timeToInteger(close);

const isWeekClosed = openingTimes => {
  const weekValues = values(openingTimes);

  const reduceNumberOfClosedDays = (accum, day) => {
    if (day.isOpened === false) {
      return accum + 1;
    }

    return accum;
  };
  const numberOfClosedDays = weekValues.reduce(reduceNumberOfClosedDays, 0);

  return numberOfClosedDays === keys(openingTimes).length;
};

const validateDay = (dayValues, weekDay) => {
  const dayErrors = {
    [weekDay]: {},
  };

  if (!dayValues.isOpened) return dayErrors;

  if (!isTimeValid(dayValues.open)) {
    dayErrors[weekDay].open = errorMsgs.default;
  }

  if (!isTimeValid(dayValues.close)) {
    dayErrors[weekDay].close = errorMsgs.default;
  }

  if (isTimeComparisonValid(dayValues.open, dayValues.close)) {
    dayErrors[weekDay].open = errorMsgs.comparison;
  }

  return dayErrors;
};

const generateFormErrorMessages = (dayValues, weekDay) => {
  if (!dayValues.isOpened) return null;

  if (!isTimeValid(dayValues.open) || !isTimeValid(dayValues.close)) {
    return {
      type: 'day',
      msg: errorMsgs.default,
      weekDay,
    };
  }

  if (isTimeComparisonValid(dayValues.open, dayValues.close)) {
    return {
      type: 'day',
      msg: errorMsgs.comparison,
      weekDay,
    };
  }

  return null;
};

const getDaysValues = (days, times) =>
  days.reduce((accum, weekDay) => {
    const openingTime = { ...DEFAULT_OPENING_TIME, ...times[weekDay] };

    return {
      ...accum,
      [weekDay]: openingTime,
    };
  }, {});

const openingTimesValidation = () => {
  return (currentValues, { initialValues }) => {
    const days = keys(initialValues);

    const daysValues = getDaysValues(days, currentValues);

    const reduceInputErrors = (accum, weekDay) => {
      return {
        ...accum,
        ...validateDay(daysValues[weekDay], weekDay),
      };
    };

    const reduceDaysIntoFormErrors = (accum, weekDay) => {
      const errors = generateFormErrorMessages(daysValues[weekDay], weekDay);

      if (errors) {
        accum.push(errors);
      }

      return accum;
    };

    if (isWeekClosed(daysValues)) {
      return {
        ...days.reduce(reduceInputErrors, {}),
        _error: [
          {
            type: 'week',
            msg: errorMsgs.weekIsClosed,
          },
        ],
      };
    }

    const formErrors = days.reduce(reduceDaysIntoFormErrors, []);

    return {
      ...days.reduce(reduceInputErrors, {}),
      _error: formErrors.length ? formErrors : undefined,
    };
  };
};

export default openingTimesValidation;



// WEBPACK FOOTER //
// ../utils/form-validations/opening-times-validation.js